import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

function Modal({ isOpen, onClose, children, className = '', requireChoice = false }) {
  useEffect(() => {
    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    document.body.style.overflowX = '';

    if (isOpen) {
      const searchInputs = document.querySelectorAll('.search-input, .global-search-bar input');
      searchInputs.forEach(input => {
        if (document.activeElement === input) input.blur();
      });
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = '';
      document.body.style.overflowX = '';
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modal = (
    <div className="modal-overlay" onClick={requireChoice ? undefined : onClose}>
      <div className={`modal-dialog ${className}`} onClick={e => e.stopPropagation()}>
        {!requireChoice && (
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        )}
        {children}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}

export default Modal; 